import React from 'react';
import { FlameGraph, RawData, ChartNode } from 'react-flame-graph';
import './BundleFlameGraph.css';

type Props = {
  data: RawData;
  onChange: (node: ChartNode, uid: string) => void;
  flameGraphRef: React.RefObject<FlameGraph>;
};

type State = {
  width: number;
  height: number;
};

class BundleFlameGraph extends React.Component<Props, State> {
  divElement: React.RefObject<HTMLDivElement> = React.createRef();

  state: State = {
    width: 0,
    height: 0,
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    setTimeout(() => this.updateDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    if (this.divElement.current) {
      const computedStyle = getComputedStyle(this.divElement.current);
      const paddingHorizontal =
        parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
      const paddingVertical =
        parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);

      const { clientWidth, clientHeight } = this.divElement.current;
      const width = clientWidth - paddingHorizontal;
      const height = clientHeight - paddingVertical;
      this.setState({ width, height });
    }
  };

  render() {
    const { data, flameGraphRef, onChange } = this.props;
    const { width, height } = this.state;
    return (
      <div className="bundle-flame-graph" ref={this.divElement}>
        <FlameGraph
          ref={flameGraphRef}
          width={width}
          height={height}
          data={data}
          onChange={onChange}
        />
      </div>
    );
  }
}

export default BundleFlameGraph;
